export const matchMediaUtil = (size: string) => {
  return window.matchMedia(`(${size})`).matches;
};
